import React from 'react';
import useTranslation from 'next-translate/useTranslation';
import { Share2 } from 'react-feather';
import CentralizeButton from '../../../../VuexyDesign/atoms/CentralizeButton';

export default function TheShareButton({
  onClick,
  className,
}: {
  onClick: () => void;
  className?: string;
}) {
  const { t } = useTranslation('tracks');
  return (
    <CentralizeButton
      style={{ width: '100%' }}
      icon={Share2}
      text={t('share') as string}
      outline
      color="secondary"
      onClick={onClick}
      className={className}
      size="sm"
    />
  );
}
